// @flow
import React, { PureComponent } from 'react';
import type { Node } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import Icon from 'Common/Icon';
import * as R from 'ramda';
import { connect } from 'react-redux';

import classNames from 'classnames';
import updateQueryString from 'Common/updateQueryString';
import { sortByValues } from 'Common/filterValues';
import { createValue, getKey } from 'Common/formValues';
import { gtmEventPush } from 'utils/gtm/events';

import styles from 'components/SortBy.scss';

const getSorter = i => {
  const sortDef = R.find(R.propEq('key', getKey(i)))(sortByValues);

  return [
    {
      key: 'sort',
      val: `${sortDef.sortBy}${sortDef.sort}`
    }
  ];
};

const isDistance = val => {
  return getKey(val) === 'distance';
};

/**
 * <SortBy /> component.
 */
class SortBy extends PureComponent<*, *> {
  /**
   * Implements propTypes().
   *
   * @return {Object} - propType object.
   */
  static propTypes = {
    isFilterMode: PropTypes.bool,
    selectedValue: PropTypes.string,
    isPostcode: PropTypes.string,
    showErrorMessage: PropTypes.bool,
    displayPostcodeErrorMessage: PropTypes.func
  };

  // TODO: SyntheticEvent wasnt the right type
  handleSortChange: (e: any) => void = e => {
    const value = e.target.value;
    const displayName = JSON.parse(value).display;
    const { displayPostcodeErrorMessage } = this.props;
    gtmEventPush({
      method: 'adListings',
      args: {
        itemLabel: `Sort by: ${displayName}`
      }
    });

    const sorter = getSorter(value);
    const { isPostcode } = this.props;
    if (isDistance(value) && !isPostcode) {
      displayPostcodeErrorMessage && displayPostcodeErrorMessage(true);
      e.preventDefault();
    } else {
      displayPostcodeErrorMessage && displayPostcodeErrorMessage(false);
      updateQueryString(sorter);
    }
  };

  /**
   * Renders <SortBy /> component.
   *
   * @return {JSX} - renders a SortBy.
   */
  render(): Node {
    const {
      isFilterMode,
      selectedValue,
      sortIcon,
      showErrorMessage,
      isLeasingPage
    } = this.props;

    const filteredSortByValues = sortByValues.filter(value =>
      isLeasingPage
        ? ['leaseAsc', 'leaseDesc'].includes(value.key)
        : !['leaseAsc', 'leaseDesc'].includes(value.key)
    );

    return (
      <div
        className={classNames(
          styles.sortBy,
          isFilterMode ? styles.filterMode : null
        )}
      >
        {!!showErrorMessage && (
          <p className={styles.message} data-test="error-msg">
            Please enter a valid UK postcode
          </p>
        )}
        {sortIcon && (
          <Icon
            iconName={'sorting'}
            size={'medium'}
            className={styles.labelIcon}
          />
        )}
        <div>
          <label htmlFor="sortBy">Sort by:</label>

          <Field
            name={'sortBy'}
            onChange={this.handleSortChange}
            component="select"
            value={selectedValue}
          >
            {filteredSortByValues.map((_, i) => (
              <option key={i} value={createValue(_)}>
                {_.display}
              </option>
            ))}
          </Field>
        </div>

        <Icon
          iconName={'chevron-down-small'}
          size={'default'}
          className={styles.icon}
        />
      </div>
    );
  }
}

function mapStateToProps(state, props) {
  const searchState = state.form.search || { values: {} };
  const initialValues = props.initialValues || searchState.values;

  return {
    initialValues: {
      postCode: state.ui.lastPostCode,
      isPostCodeValid: Boolean(state.ui.lastPostCode),
      ...initialValues
    }
  };
}

// eslint-disable-next-line no-class-assign
const ReduxSortBy = reduxForm({
  form: 'search',
  enableReinitialize: true,
  destroyOnUnmount: false
})(SortBy);

export default (connect(mapStateToProps)(ReduxSortBy): any);



// WEBPACK FOOTER //
// ./src/Common/SortBy/index.js